/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CategoryEvent,
} from '../models/index';
import {
    CategoryEventFromJSON,
    CategoryEventToJSON,
} from '../models/index';

/**
 * 
 */
export class CategoryEventApi extends runtime.BaseAPI {

    /**
     * Get all category to event
     */
    async getAllCategoryEventRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CategoryEvent>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/category-event`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CategoryEventFromJSON));
    }

    /**
     * Get all category to event
     */
    async getAllCategoryEvent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CategoryEvent>> {
        const response = await this.getAllCategoryEventRaw(initOverrides);
        return await response.value();
    }

}
